import React from 'react';
import './CodingJourney.css';
import image from './github_logo-min.png';
import linkedin from './LI-In-Bug.png';
import medium from './medium-min.jpg';
import wangari from './Wangari-Maathai-Muta-min.jpg';
import kiaNews from './globalnews-min.jpg';
import leDocumentaire from './documented-min.jpg';

const projects = {
  1: {
    "title": 'Wangari Maathai Tribute',
    "img_src": wangari,
    "url": "https://codepen.io/lwanjiru/full/wjxKXW/"
  },
  2: {
    "title": 'KI All News Site(Archived)',
    "img_src": kiaNews,
    "url": "https://web.archive.org/web/20200605191240/https://ki-all-news.herokuapp.com/"
  },
  3: {
    "title": 'Le Documentaire API(Documentation)',
    "img_src": leDocumentaire,
    "url": "https://ledocumentaire.docs.apiary.io/"
  }
};

const loopProjects = Object.entries(projects).map(([projectId, project]) => (
  <a
    key={projectId}
    className="card col-lg-3 m-1 text-dark"
    href={project.url}
    target="_blank"
    rel="noopener noreferrer"
  >
    <div id="journey-cards" className="card-header">
      {project.title}
    </div>
    <div className="card-body">
      <img className="card-img-top" src={project.img_src} alt="project figure" />
    </div>
  </a>
));

const linkedIn = (
  <div className="pt-3 pb-3 text-center mt-2 ml-2 mr-2">
    <h5><a className="" href="https://www.linkedin.com/in/nyawira-w-32975320" target="_blank" rel="noopener noreferrer"><u>LinkedIn profile</u></a></h5>
    <a className="card pb-2" href="https://www.linkedin.com/in/nyawira-w-32975320" target="_blank" rel="noopener noreferrer"><img className="img img-fluid pb-2" src={linkedin} alt="linkedin logo" style={{width : 220 + 'px'}} /></a>
  </div>
);

const github = (
  <div className="pt-3 pb-3 text-center mt-2 ml-2 mr-2">
    <h5><a className="" href="https://github.com/LWanjiru" target="_blank" rel="noopener noreferrer"><u>Github profile</u></a></h5>
    <a className="card pb-2" href="https://github.com/LWanjiru" target="_blank" rel="noopener noreferrer"><img className="img img-fluid pb-2" src={image} alt="github logo" style={{width : 200 + 'px'}} /></a>
  </div>
);

const medium_profile = (
  <div className="pt-3 pb-3 text-center mt-2 ml-2 mr-2">
  <h5><a className="" href="https://medium.com/@leenjiru1" target="_blank" rel="noopener noreferrer"><u>Medium Profile</u></a></h5>
  <a className="card pb-2" href="https://medium.com/@leenjiru1" target="_blank" rel="noopener noreferrer"><img className="img img-fluid pb-2 h-auto" src={medium} alt="medium logo" style={{width : 190 + 'px'}} /></a>
</div>
)

const details = (
  <div className="pb-5 container">
    <div className="portfolio-page text-center pt-5 pb-5 mb-5 ">
      <h1 className='bg-title '><span><strong> Portfolio </strong></span></h1>
    </div>
    <div className="text-center mb-3">
      <h2><u>Projects</u></h2>
    </div>
    <div className="row justify-content-center">
      {loopProjects}
    </div>
    <div className="text-center mt-5 pt-lg-2">
      <h3 className="pt-5">For more on my work experience, writing and codebases visit:-</h3>
    </div>
    <div className="row justify-content-center pt-0 pb-3 mb-5 mb-lg-0">
      <div>{linkedIn}</div>
      <div>{github}</div>
      <div>{medium_profile}</div>
      
    </div>
  </div>
)


const CodingJourney = () => { return details }

export default CodingJourney;